import { render, staticRenderFns } from "./HotGoods.vue?vue&type=template&id=38430060&scoped=true&"
import script from "./HotGoods.vue?vue&type=script&lang=js&"
export * from "./HotGoods.vue?vue&type=script&lang=js&"
import style0 from "./HotGoods.vue?vue&type=style&index=0&id=38430060&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38430060",
  null
  
)

export default component.exports